import { FC } from 'react'
import { ResponsiveImage } from './responsiveImage'
import styled from 'styled-components'

interface ImageCollectionProps {
    urls?: string[]
}

const Container = styled.div`
    display: flex;
`

export const ImageCollection: FC<ImageCollectionProps> = ({ urls }) => {
    return (
        <Container>
            {urls?.map((url, index) => {
                return <ResponsiveImage src={url} key={index} />
            })}
        </Container>
    )
}
